import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  cancelled: {
    description: 'orderStatusLabel.cancelled',
    defaultMessage: 'Cancelled',
    id: 'uxdhkn',
  },
  awaitingpayment: {
    description: 'orderStatusLabel.awaitingPayment',
    defaultMessage: 'Awaiting Payment',
    id: 'PxpFoL',
  },
  awaitingshipment: {
    description: 'orderStatusLabel.awaitingShipment',
    defaultMessage: 'Awaiting Shipment',
    id: 'vjgY9X',
  },
  shipped: {
    description: 'orderStatusLabel.shipped',
    defaultMessage: 'Shipped',
    id: 'cYB5DR',
  },
  onhold: {
    description: 'orderStatusLabel.onHold',
    defaultMessage: 'On Hold',
    id: 'hHPvY3',
  },
  pendingfulfillment: {
    description: 'orderStatusLabel.pendingFulfillment',
    defaultMessage: 'Pending Fulfillment',
    id: 'FHOsnz',
  },
  rejectedfulfillment: {
    description: 'orderStatusLabel.rejectedFulfillment',
    defaultMessage: 'Rejected Fulfillment',
    id: 'MXw9Rw',
  },
  pendingpickup: {
    description: 'orderStatusLabel.pendingPickup',
    defaultMessage: 'Pending Pickup',
    id: '4A541P',
  },
});
